import React from "react";
import { Error404, Error500 } from "@features/error";

class CustomErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorStatus: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, errorStatus: error?.response?.status || 500 };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error caught by ErrorBoundary:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            if (this.state.errorStatus === 500) {
                return <Error500 />;
            }
            return <Error404 />;
        }

        return this.props.children;
    }
}

export default CustomErrorBoundary;
